export type ErrorPageMessages = {
  [key: string]: string
}

const errorPageMessages: ErrorPageMessages = {
  // Deal Restriction Errors
  DEAL_RESTRICTED: 'The inserted deal number is restricted.',
  DEAL_FROZEN: 'This deal is frozen and cannot be accessed.',
  INVALID_DEAL: 'The deal number entered is invalid.',
  // Authentication Errors
  AUTHENTICATION_FAILED: 'User authentication failed. Please check your credentials and try again.',
  ACCESS_DENIED: 'You do not have permission to access this deal.',
  // General Errors
  GENERAL_ERROR: 'An unexpected error has occurred. Please try again later.',
  // ErrorMessageURL
  MISSING_DEAL_NUMBER: 'Deal number is not specified in the URL.',
  MISSING_DECISION: 'URL contains wrong information. Please correct',
  MISSING_PATH_PARAMS: 'URL contains wrong information. Please correct',
  INVALID_DEAL_NUMBER: 'Inserted deal number is invalid.',
  MISSING_EMAIL_ID: 'Email ID is not specified in the URL.',
}

export default errorPageMessages
